export const ChartScoreStructure = {
    credits: {
        enabled: false
    },
    exporting: {
        enabled: false
    },

    chart: {
        type: "gauge",
        backgroundColor: "transparent",
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false
    },

    title: {
        text: ""
    },

    pane: {
        background: null,
        startAngle: -90,
        endAngle: 90
    },

    tooltip: {
        enabled: false
    },

    // the value axis
    yAxis: {
        lineWidth: 0,
        min: 0,
        max: 100,
        minorTickInterval: "auto",
        minorTickWidth: 1,
        minorTickLength: 10,
        minorTickPosition: "inside",
        minorTickColor: "#666",

        tickPixelInterval: 1,
        tickWidth: 0,
        tickPosition: "side",
        tickLength: 10,
        tickColor: "#666",
        labels: {
            enabled: false,
            step: 2
        },
        title: {
            enabled: false,
            text: ""
        },
        plotBands: [
            {
                from: 0,
                to: 10,
                color: "#9500B3",
                thickness: "50%"
            },
            {
                from: 10,
                to: 20,
                color: "#B500D9",
                thickness: "50%"
            },
            {
                from: 20,
                to: 30,
                color: "#D500FF",
                thickness: "50%"
            },
            {
                from: 30,
                to: 35,
                color: "#E67E00",
                thickness: "50%"
            },
            {
                from: 35,
                to: 41,
                color: "#FFB700",
                thickness: "50%"
            },
            {
                from: 41,
                to: 51,
                color: "#FFE200",
                thickness: "50%"
            },
            {
                from: 51,
                to: 66,
                color: "#009DA2",
                thickness: "50%"
            },
            {
                from: 66,
                to: 81,
                color: "#00B9BF",
                thickness: "50%"
            },
            {
                from: 81,
                to: 100,
                color: "#00CBD2",
                thickness: "50%"
            }
        ]
    },

    series: [
        {
            name: "Progress",
            data: [40],
            dataLabels: { enabled: false }
        }
    ]
};
